import { Component, Enum, Node, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import { Unit } from '../../../../../common/scripts/Account';

const { ccclass, property } = _decorator;

@ccclass('UnitSwitcher')
export default class UnitSwitcher extends Component {
    public static readonly EVENT_DISPLAY_UNIT_CHANGED = 'display-unit-changed';

    private static _unit: Unit = Unit.Dollar;

    @property
    private readonly resetUnitOnDisplay: boolean = true;

    @property({
        type: Enum(Unit),
        visible() {
            return this.resetUnitOnDisplay;
        },
    })
    private readonly resetUnit: Unit = Unit.Dollar;

    public static get unit() {
        return this._unit;
    }
    public static set unit(value: Unit) {
        if (value === this._unit) {
            return;
        }
        this._unit = value;
        Lobby.event.emit(UnitSwitcher.EVENT_DISPLAY_UNIT_CHANGED);
    }

    protected onLoad() {
        this.node.on(Node.EventType.TOUCH_END, this._switchUnit, this);
    }

    protected onEnable() {
        if (this.resetUnitOnDisplay) {
            UnitSwitcher.unit = this.resetUnit;
        }
    }

    private _switchUnit() {
        UnitSwitcher.unit = UnitSwitcher.unit === Unit.Dollar ? Unit.Credit : Unit.Dollar;
    }
}
